// src/pages/CourseTime/components/activities/ShareWorkActivity.comp.jsx
import React from 'react';
import * as S from '../../styles';
import {FullActivityPill} from "../../styles";
import { GET_APP_LOCALIZE_TEXT } from '../../../../utils/dq_lc_service/lc_service';
import { renderPlainTextWithFormatting } from '../../utils';


const ShareWorkActivity = ({
  slide,
  shareWorkLink,
  setShareWorkLink,
  onSubmit,
  onEditActivity,
  interactionLoading,
  fetchingExistingRecord,
  inputsDisabled,
  activityCompleted,
  themeColor,
  pageLc
}) => {
  const renderHtmlContent = (content) => {
    if (!content) return null;
    const text = String(content).trim();
    const hasHtml = /<[^>]+>/.test(text);
    return hasHtml
      ? <span dangerouslySetInnerHTML={{ __html: text }} />
      : renderPlainTextWithFormatting(text);
  };

  return (
    <S.ActivityWrapper>
      <S.ShareFileActivityContainer>
        {/* Left side */}
        <S.ActivityLeft>
          <S.FullActivityPill>{GET_APP_LOCALIZE_TEXT(pageLc, 'ct__share_work_time')}!</S.FullActivityPill>
          <S.ActivityTitle>{renderHtmlContent(slide.SlideTitle)}</S.ActivityTitle>
          <S.ActivityContent>{renderHtmlContent(slide.SlideContent)}</S.ActivityContent>
          {/* A design challenge (newer content) also has a starter scenario,
              success criteria and a tip — the parts the PW preview shows. */}
          {slide.starter_artifact && (
            <S.ActivityContent><strong>Starter Scenario:</strong> {renderHtmlContent(slide.starter_artifact)}</S.ActivityContent>
          )}
          {Array.isArray(slide.scenario_bullets) && slide.scenario_bullets.length > 0 && (
            <S.ActivityContent as="ul">
              {slide.scenario_bullets.map((b, idx) => <li key={idx}>{renderHtmlContent(b)}</li>)}
            </S.ActivityContent>
          )}
          {Array.isArray(slide.success_criteria) && slide.success_criteria.length > 0 && (
            <>
              <S.ActivityContent><strong>Success Criteria</strong></S.ActivityContent>
              <S.ActivityContent as="ol">
                {slide.success_criteria.map((c, idx) => <li key={idx}>{renderHtmlContent(c)}</li>)}
              </S.ActivityContent>
            </>
          )}
          {slide.tactical_tip && (
            <S.ActivityContent><strong>Tactical tip:</strong> {renderHtmlContent(slide.tactical_tip)}</S.ActivityContent>
          )}
        </S.ActivityLeft>

        {/* Right side */}
        <S.ShareWorkRight>
          <S.LinkInput
            type="url"
            placeholder={GET_APP_LOCALIZE_TEXT(pageLc, 'ct__share_work_placeholder')}
            value={shareWorkLink}
            onChange={(e) => setShareWorkLink(e.target.value)}
            disabled={inputsDisabled}
            themeColor={themeColor}
          />

          {/*<S.Text>OR</S.Text>*/}

          {/*<S.FileUploadButton type="button">*/}
          {/*  Upload File<br/>*/}
          {/*  (JPG, PNG, PDF, Excel, and Word Doc accepted)*/}
          {/*</S.FileUploadButton>*/}

          <S.SubmitButton
            onClick={() => onSubmit(slide)}
            disabled={!shareWorkLink.trim() || interactionLoading || inputsDisabled}
          >
            {interactionLoading ? GET_APP_LOCALIZE_TEXT(pageLc, 'ct__submitting') + '...' : activityCompleted[slide.SlideID] ? GET_APP_LOCALIZE_TEXT(pageLc, 'ct__submitted') : GET_APP_LOCALIZE_TEXT(pageLc, 'ct__submit')}
          </S.SubmitButton>
          
          {/* Response saved indicator */}
          {inputsDisabled && !fetchingExistingRecord && activityCompleted[slide.SlideID] && (
            <S.ResponseSavedWrapper>
              <S.ResponseSavedIndicator>
                <i className="fa fa-lock" style={{ marginRight: "6px" }} />
                {GET_APP_LOCALIZE_TEXT(pageLc, 'ct__response_submitted')}
              </S.ResponseSavedIndicator>
              <S.EditButton 
                onClick={() => onEditActivity(slide)}
                title="Edit response"
                themeColor={themeColor}
              >
                <i className="fa fa-pencil" />
              </S.EditButton>
            </S.ResponseSavedWrapper>
          )}
        </S.ShareWorkRight>
      </S.ShareFileActivityContainer>

      {/* Loading overlay */}
      {fetchingExistingRecord && (
        <S.ActivityLoadingOverlay>
          <S.LoadingSpinner />
          <S.LoadingText>{GET_APP_LOCALIZE_TEXT(pageLc, 'ct__loading_existing_record')}...</S.LoadingText>
        </S.ActivityLoadingOverlay>
      )}
    </S.ActivityWrapper>
  );
};

export default ShareWorkActivity;
